import { api } from "@/lib/api";
import {
  Agency,
  AgencyDtoSchema,
  agencyFromDto,
  CreateAgency,
  createAgencyToDto,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getAgenciesQueryOptions } from "./get.hooks";

export function useCreateAgency(opts?: {
  onSuccess?: (agency: Agency) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (agency: CreateAgency) => {
      const dto = createAgencyToDto(agency);
      const result = await api.post("/api/agencies", dto, AgencyDtoSchema);
      return agencyFromDto(result);
    },
    onSuccess: (agency) => {
      queryClient.setQueryData(getAgenciesQueryOptions.queryKey, (old) => [
        ...(old ?? []),
        agency,
      ]);
      toast({
        title: "toast.agencyCreated",
        variant: "success",
      });
      opts?.onSuccess?.(agency);
    },
    onError: () => {
      toast({
        title: "toast.createAgencyError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
